import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    // System permissions (for admin)
    allPermissions: [],
    allPermissionsLoading: false,
    allPermissionsError: null,

    // User permissions
    userPermissions: [],
    userPermissionsLoading: false,
    userPermissionsError: null,
    initialized: false,
    lastUpdated: null
};

const permissionSlice = createSlice({
    name: 'permission',
    initialState,
    reducers: {
        allPermissionsLoaded(state, action) {
            state.allPermissions = action.payload.permissions;
            state.allPermissionsLoading = false;
            state.allPermissionsError = null;
            state.lastUpdated = new Date().toISOString();
        },

        userPermissionsLoaded(state, action) {
            state.userPermissions = action.payload.permissions;
            state.userPermissionsLoading = false;
            state.userPermissionsError = null;
            state.initialized = true;
            state.lastUpdated = new Date().toISOString();
        },

        allPermissionsLoadingStarted(state) {
            state.allPermissionsLoading = true;
            state.allPermissionsError = null;
        },

        userPermissionsLoadingStarted(state) {
            state.userPermissionsLoading = true;
            state.userPermissionsError = null;
        },

        allPermissionsLoadingFailed(state, action) {
            state.allPermissionsLoading = false;
            state.allPermissionsError = action.payload.error;
        },

        userPermissionsLoadingFailed(state, action) {
            state.userPermissionsLoading = false;
            state.userPermissionsError = action.payload.error;
            state.initialized = true;
        },

        reset() {
            return initialState;
        }
    }
});

export const permissionActions = permissionSlice.actions;
export const permissionReducer = permissionSlice.reducer;